import Button from "../../common/elements/Button";

const ConfirmDialog = ({
    isActive,
    title = 'Confirm',
    message,
    onConfirm,
    onCancel,
    confirmLabel = 'Confirm',
    confirmClass = 'is-danger',
}) => (
    <div className={`modal ${isActive ? 'is-active' : ''}`}>
        <div className="modal-background" onClick={onCancel} />
        <div className="modal-card">
            <header className="modal-card-head">
                <p className="modal-card-title">{title}</p>
                <button className="delete" onClick={onCancel} />
            </header>
            <section className="modal-card-body">
                {message}
            </section>
            <footer className="modal-card-foot">
                <Button className={`${confirmClass} mr-2`} onClick={onConfirm}>{confirmLabel}</Button>
                <Button onClick={onCancel}>Cancel</Button>
            </footer>
        </div>
    </div>
);

export default ConfirmDialog;
